var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRoundeRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 21.182,
    height: 21.182,
    rx: 10.591,
    fill: "#EE3124"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.9652 7.31055L8.95068 13.3251L6.2168 10.5912",
    stroke: "#F8F8F8",
    strokeWidth: 1.64033,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRoundeRight);
export default __webpack_public_path__ + "static/media/rounde-right.c8bf2fa92e734a85cb887f8df116ea68.svg";
export { ForwardRef as ReactComponent };